module.exports = "https://product-cdn.staging.surfline.com/kbyg/_next/static/images/article-no-image-30057ad7acdd664bb731f9c001552011.png";